import neoSwitch from "@/components/toggle-switch";
import {get} from "lodash";
import {mapGetters} from "vuex";
import axios from "@/axios";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import Loader from "@/components/loader";
import {DateTime} from "luxon";
import ResultList from "@/components/result-list";

export default {
    components: {
        neoSwitch,
        "neo-loader": Loader,
        ResultList,
    },
    props: {
        timeline: {
            type: Object,
            default: () => {},
        },
        monitoring: {
            type: Boolean,
            default: false,
        },
        isAllRunQueries: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            monitoringHistoryIndex: null,
        };
    },
    methods: {
        getFormattedTime(ts) {
            if (ts) {
                let date = new Date(ts).toISOString();
                date = DateTime.fromISO(date);
                return date.toFormat("dd MMM yyyy");
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters([]),
        isMonitoringTab() {
            return this.$route.name === "monitoring";
        },
    },
};
